import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";

import DoneSearch from "../components/DoneSearch";
import DoneTable from "../components/DoneTable";

const OrdersDone = (props) => {
	const [done, setDone] = useState([]);
	const [page, setPage] = useState(1);
	const [pageCount, setPageCount] = useState(1);

	//getting the data from search component
	const getOrderData = (data, count) => {
		setDone(data);
		setPageCount(count);
	};

	//getting the data from the pagination
	const getPage = (data) => {
		setPage(data);
	};

	return (
		<React.Fragment>
			<Grid container spacing={4}>
				<Grid md={12}>
					<DoneSearch
						getOrderData={getOrderData}
						page={page}
						rowCount={15}
					/>
				</Grid>
				<Grid md={12}>
					<DoneTable
						data={done}
						getPage={getPage}
						pageCount={pageCount}
					/>
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default OrdersDone;
